<template>
  <svg
    height="800"
    viewBox="0 0 20 20"
    width="800"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path :d="path" :fill="props.color" />
  </svg>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import type { Logos } from "@/components/HydrusRating/SymbolPaths";
import { logos } from "@/components/HydrusRating/SymbolPaths";

const props = defineProps<{
  symbol: Logos;
  color?: string;
}>();

const path = computed<string>(() => logos[props.symbol]);
</script>

<style scoped>
svg {
  width: 1em;
  height: 1em;
}
</style>
